/* ================== *
 *      GET USER      *
 * ================== */

import { DataConfig } from "@/components/table/useDefaultDataConfig";
import { Paginated } from "./types";
import { generateParams } from "@/utils/helper/generateParams";
import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/utils/lib/axios";

type UserData = {
  id: string;
  username: string;
  email: string;
  role: string;
  companyCode: string;
};

type UsersQueryKey = DataConfig & {
  role?: string;
  companyCode?: string;
};

interface UserList extends Paginated {
  content: UserData[];
}

async function getUsers(
  queryFunctionContext: QueryFunctionContext,
): Promise<UserList> {
  const { queryKey } = queryFunctionContext;
  const [_, userQueryKey] = queryKey;
  const params = generateParams(userQueryKey as UsersQueryKey);

  const response = await axiosInstance.get("/api/crud/user" + params);
  return response.data.data;
}

function useUsers(
  usersQueryKey: UsersQueryKey = {},
  options?: {
    enabled?: boolean;
  },
) {
  return useQuery({
    ...options,
    queryKey: ["users", usersQueryKey],
    queryFn: getUsers,
  });
}

export type { UserData };
export { useUsers };
